import { useState, useEffect } from 'react';
import { Order } from '../types';

interface OrderTimer {
    timeLeft: string;
    isOverdue: boolean;
    progress: number; // 0 to 100
}

export function useOrderTimer(order: Order): OrderTimer | null {
    const [timer, setTimer] = useState<OrderTimer | null>(null);

    useEffect(() => {
        if (!order.estimated_time || !order.created_at) {
            setTimer(null);
            return;
        }

        const calculateTime = () => {
            const created = new Date(order.created_at!).getTime();
            const [hours, minutes, seconds] = order.estimated_time!.split(':').map(Number);
            const durationMs = ((hours * 60 * 60) + (minutes * 60) + seconds) * 1000;
            const targetTime = created + durationMs;
            const now = new Date().getTime();
            const diff = targetTime - now;

            if (diff <= 0) {
                setTimer({
                    timeLeft: "00:00",
                    isOverdue: true,
                    progress: 100
                });
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);
            const m = Math.floor(totalSeconds / 60);
            const s = totalSeconds % 60;

            // Calculate progress
            const elapsed = now - created;
            const progress = Math.min(Math.max((elapsed / durationMs) * 100, 0), 100);

            setTimer({
                timeLeft: `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`,
                isOverdue: false,
                progress
            });
        };

        calculateTime();
        const interval = setInterval(calculateTime, 1000);

        return () => clearInterval(interval);
    }, [order.estimated_time, order.created_at]);

    return timer;
}
